/* Verolae · Proven Benefit — behaviour ported from the original product-page
   section script ("Flip Logic"):
   - clicking a card flips it (adds `.flip`), closes every other card in the same
     section and swaps the toggle glyph between "+" and "–" (U+2013);
   - the CTA button, when the page has an add-to-cart button (.product-form__submit),
     smooth-scrolls to it instead of navigating (source did this on the product page).
   Scoped per section instance, guarded against double init, analytics-free. */
(function () {
  'use strict';

  var PLUS = '+';
  var MINUS = '–';

  function setCard(card, open) {
    var icon = card.querySelector('.toggle-icon');
    if (open) {
      card.classList.add('flip');
    } else {
      card.classList.remove('flip');
    }
    if (icon) icon.textContent = open ? MINUS : PLUS;
    card.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initSection(root) {
    if (!root || root.dataset.verolaeProvenBenefitReady === 'true') return;
    root.dataset.verolaeProvenBenefitReady = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));

    function toggle(card) {
      var isOpen = card.classList.contains('flip');

      /* Close all others (source behaviour) */
      cards.forEach(function (other) {
        if (other !== card) setCard(other, false);
      });

      /* Toggle this card */
      setCard(card, !isOpen);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        toggle(card);
      });
      /* keyboard support for the role="button" card (invisible addition) */
      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          toggle(card);
        }
      });
    });

    /* CTA scroll logic */
    if (root.dataset.ctaScrollToAtc === 'true') {
      Array.prototype.forEach.call(root.querySelectorAll('.benefits-cta-btn-js'), function (btn) {
        btn.addEventListener('click', function (event) {
          var atcButton = document.querySelector('.product-form__submit');
          if (atcButton) {
            event.preventDefault();
            atcButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      });
    }
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    if (ctx !== document && ctx.matches && ctx.matches('[data-verolae-proven-benefit]')) {
      initSection(ctx);
    }
    Array.prototype.forEach.call(ctx.querySelectorAll('[data-verolae-proven-benefit]'), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Theme editor: initialise re-rendered sections and flip the selected block open */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target && event.target.closest ? event.target.closest('[data-card]') : null;
    if (!card || !card.closest('[data-verolae-proven-benefit]')) return;
    if (!card.classList.contains('flip')) card.click();
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var card = event.target && event.target.closest ? event.target.closest('[data-card]') : null;
    if (!card || !card.closest('[data-verolae-proven-benefit]')) return;
    if (card.classList.contains('flip')) card.click();
  });
})();
